import React from "react";
import { Star } from "lucide-react";
import DeferredVideo from "./DeferredVideo";

export default function FetaHighlightSection({
  videoSrc,
  videoPoster,
  tag,
  title,
  description,
  buttonText,
  buttonLink,
  reviewerImage,
  chefImage,
  reviewerName,
  reviewerText,
  rating = 5,
}) {
  return (
    <section className="py-16 bg-[#F9F7F8]">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
        
        {/* LEFT: VIDEO */}
        <div className="md:w-1/2 w-full rounded-2xl overflow-hidden shadow-lg">
          <DeferredVideo
            src={videoSrc}
            poster={videoPoster}
            className="w-full object-cover rounded-2xl"
            style={{
              maxHeight: "460px",
            }}
          />
        </div>

        {/* RIGHT: CONTENT */}
        <div className="md:w-1/2 w-full">
          <div className="flex items-center gap-2 mb-3">
            <img
              src={chefImage}
              alt={reviewerName}
              width={32}
              height={32}
              loading="lazy"
              decoding="async"
              className="w-8 h-8 rounded-full object-cover"
            />
            <span className="text-sm bg-gray-100 px-3 py-1 rounded-full text-gray-700 font-medium">
              {tag}
            </span>
          </div>

          <h2 className="text-4xl font-semibold text-gray-900 mb-4">
            {title}
          </h2>

          <p className="text-gray-700 mb-6 leading-relaxed">{description}</p>

          <a
            href={buttonLink}
            className="inline-block bg-[#C03CA0] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#a03083] transition"
          >
            {buttonText}
          </a>

          {/* REVIEW BLOCK */}
          <div className="mt-8 flex items-start gap-3">
            <img
              src={reviewerImage}
              alt={reviewerName}
              width={40}
              height={40}
              loading="lazy"
              decoding="async"
              className="w-10 h-10 rounded-full object-cover"
            />
            <div>
              <div className="flex items-center gap-1 mb-1">
                {Array.from({ length: rating }).map((_, i) => (
                  <Star key={i} size={16} className="fill-[#FFD369] text-[#FFD369]" />
                ))}
              </div>
              <p className="text-sm text-gray-600 italic mb-1">{reviewerText}</p>
              <p className="text-sm font-semibold text-gray-800">{reviewerName}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
